import { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { i18n, SSRConfig } from 'next-i18next';
import { AppProps } from 'next/app';
import ErrorPage from '@sy/app-client/src/ssrAdapter/pages/ErrorPage';
import { logger } from '@sy/logger';

import type { DefaultContext } from '../getServerSideProps';

type ErrorPageProps = AppProps & SSRConfig;

const CustomError: NextPage<ErrorPageProps> = () => {
	return <ErrorPage i18n={i18n} />;
};

export async function getStaticProps(context: DefaultContext) {
	try {
		return {
			props: {
				...(await getTranslationsForAllLocales(context)),
			},
		};
	} catch (error) {
		logger.error('ErrorPage getServerSideProps failed', {
			error,
		});

		throw error;
	}
}

async function getTranslationsForAllLocales(context: DefaultContext) {
	const namespaces = ['common', 'auth'];
	try {
		return await serverSideTranslations(
			context.defaultLocale,
			namespaces,
			undefined,
			context.locales,
		);
	} catch (error) {
		logger.error('ErrorPage getTranslationsForAllLocales failed', error);
	}
	return undefined;
}

export default CustomError;
